import type { FieldCodec } from 'v5/core/entity-values/values.types';
import { customFieldColumns } from './customFieldColumns';
import { findCustomFieldRowForRead } from './customFieldRows';
import { validateField, validation } from './validation';

function isEmpty(value: string | null): boolean {
  return value === null || value === '';
}

/** Form values are option ids as strings; `option_id` is numeric. */
function toOptionId(value: string | null): number | null {
  if (isEmpty(value)) return null;
  const id = Number(value);
  return Number.isInteger(id) ? id : null;
}

/** SINGLE_SELECT custom field. */
export const singleSelectCodec: FieldCodec<'single-select'> = {
  decode(entity, spec, ctx) {
    const row = findCustomFieldRowForRead(entity, spec.definition.id, ctx);
    return row?.option_id == null ? null : String(row.option_id);
  },
  encode(value) {
    return {
      type: 'custom',
      columns: customFieldColumns({ option_id: toOptionId(value) })
    };
  },
  empty() {
    return null;
  },
  isEmpty,
  validate(value, spec) {
    return validateField(value, spec, isEmpty, value =>
      !isEmpty(value) && toOptionId(value) === null
        ? validation.invalid({ code: 'invalid-option' })
        : validation.valid()
    );
  }
};
